// extracted by mini-css-extract-plugin
export var labelWrapper = "_gq-0";